import InvoiceTemplate from '@/views/templates/Invoice.vue'

const router = {
  path: '/invoice-template',
  name: 'invoice-template',
  component: InvoiceTemplate,
  meta: {
    title: 'Invoice Template'
  }
};

export default router
